export default {"src":"/_next/static/media/location-marker-light.c625cce1.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};